<template>
    <div>
        <slot :performances="performances" :imageUrl="imageUrl" :hasFavorite="hasFavorite" :addToFavorites="addToFavorites" :favorites="favorites" :removeFromFavorites="removeFromFavorites" :formatEventDate="formatEventDate"></slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref, inject } from 'vue';
import { getPerformances } from '../services/inventory';
import { getCookie } from '../utils/cookie-handler'
import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { groupBy } from 'lodash';

export default defineComponent({
    name: 'WhatsOnFavorites',
    props: {

    },
    setup(props) {
        const performances = ref([]);
        const favorites = ref([]);

        const imageUrl = inject('imageUrl');
        const FAVORITES_COOKIE = 'favorites';

        onMounted(async () => {
            performances.value = await getPerformances();
            updateFavorites();
        })

        const hasFavorite = function(performance) {
            return favorites.value.includes( parseInt(performance.tessitura.performanceId, 10) );
        }

        const addToFavorites = async function(performance) {
            const res = await fetch(`https://tickets.tco.devspace.net/api/favorites/add/${performance.tessitura.performanceId}`, {
                method: "POST",
                headers: {
                    Authorization: `Basic ${btoa('preview:preview')}`,
                }
            })

            const data = await res.json();

            updateFavorites();
        }

        const removeFromFavorites = async function(performance) {
            const res = await fetch(`https://tickets.tco.devspace.net/api/favorites/remove/${performance.tessitura.performanceId}`, {
                method: "POST",
                headers: {
                    Authorization: `Basic ${btoa('preview:preview')}`,
                }
            })

            const data = await res.json();

            updateFavorites();
        }

        const updateFavorites = function() {
            const cookie = getCookie(FAVORITES_COOKIE);

            if (cookie) {
                favorites.value = JSON.parse(cookie).pNos;
            }
        }

        const formatEventDate = function(event) {
            const startDate = event.startDate ? new Date(event.startDate) : null;
            const endDate = event.endDate ? new Date(event.endDate) : null;
            const currentYear = new Date().getFullYear();
            const startYear = startDate.getFullYear();
            //const startMonthDay = startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

            let startFormatOptions = { month: 'short', day: 'numeric' };
            let endFormatOptions = { month: 'short', day: 'numeric' };

            if (endDate) {
                const endYear = endDate.getFullYear();

                if (startYear !== endYear) {
                    startFormatOptions.year = 'numeric';
                    endFormatOptions.year = 'numeric';
                } else if (startYear !== currentYear) {
                    endFormatOptions.year = 'numeric';
                }

                const formattedStart = startDate.toLocaleDateString('en-US', startFormatOptions);
                const formattedEnd = endDate.toLocaleDateString('en-US', endFormatOptions);
                return `${formattedStart} - ${formattedEnd}`;
            } else {
                if (startYear !== currentYear) {
                    startFormatOptions.year = 'numeric';
                }

                let result = startDate.toLocaleDateString('en-US', startFormatOptions);

                const hour = startDate.getHours();
                const minute = startDate.getMinutes();

                if (hour !== 0 || minute !== 0) {
                    const time = startDate.toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: minute === 0 ? undefined : '2-digit',
                        hour12: true,
                    }).toLowerCase();
                    result += ` at ${time}`;
                }

                return result;
            }
        }

        return {
            performances,
            imageUrl,
            hasFavorite,
            addToFavorites,
            favorites,
            removeFromFavorites,
            formatEventDate
        }
    },
});
</script>
